import React from "react";
import { Link } from "react-router-dom";

export default function PrivacyPage() {
  return (
    <div className="bg-gradient-to-b from-orange-400 via-orange-100 to-white min-h-screen flex flex-col">
      {/* Animated SVG/CSS background for the entire page */}
      <div className="fixed inset-0 pointer-events-none z-0 w-full h-full">
        <svg width="100%" height="100%" className="w-full h-full animate-pulse-slow" style={{position:'absolute',top:0,left:0}}>
          <circle cx="30%" cy="30%" r="180" fill="none" stroke="#fbb6ce" strokeWidth="2" opacity="0.2">
            <animate attributeName="r" values="180;200;180" dur="6s" repeatCount="indefinite" />
          </circle>
          <circle cx="70%" cy="60%" r="120" fill="none" stroke="#a5b4fc" strokeWidth="2" opacity="0.15">
            <animate attributeName="r" values="120;140;120" dur="7s" repeatCount="indefinite" />
          </circle>
          <path d="M 0 400 Q 400 200 1200 400" stroke="#f472b6" strokeWidth="1.5" fill="none" opacity="0.12">
            <animate attributeName="d" values="M 0 400 Q 400 200 1200 400;M 0 420 Q 400 220 1200 420;M 0 400 Q 400 200 1200 400" dur="8s" repeatCount="indefinite" />
          </path>
        </svg>
      </div>
      {/* Header */}
      <nav className="relative z-10 w-full flex items-center justify-between px-20 py-6 bg-transparent">
        <div className="flex items-center gap-2">
          <img src="/icons/icon.svg" alt="Logo" className="h-8 w-8" />
          <span className="text-2xl font-bold text-gray-900 tracking-tight">Hintword</span>
        </div>
      </nav>
      <main className="flex-1 flex flex-col items-center justify-center px-4 py-16 z-10">
        <div className="max-w-5xl w-full bg-white/90 rounded-xl shadow-md p-8">
          <h1 className="text-3xl font-bold mb-6 text-gray-900">Privacy Policy</h1>
          <p className="mb-4 text-gray-700">
            Your privacy is important to us. This Privacy Policy explains how Hintword Studio collects, uses, and protects your information.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-2">1. Information We Collect</h2>
          <p className="mb-4 text-gray-700">
            We collect information you provide (such as notes, tab collections, and account details) and usage data (such as device and browser information).
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-2">2. How We Use Information</h2>
          <p className="mb-4 text-gray-700">
            We use your information to provide, improve, and personalize Hintword Studio. We may use anonymized data to improve our AI features.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-2">3. Data Sharing</h2>
          <p className="mb-4 text-gray-700">
            We do not sell your personal information. We may share data with trusted service providers for hosting, analytics, or AI processing, but only as necessary to provide the service.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-2">4. Data Security</h2>
          <p className="mb-4 text-gray-700">
            We use industry-standard security measures to protect your data. However, no system is 100% secure.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-2">5. Your Choices</h2>
          <p className="mb-4 text-gray-700">
            You can access, update, or delete your data at any time. Contact us if you need help managing your information.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-2">6. Changes to This Policy</h2>
          <p className="mb-4 text-gray-700">
            We may update this Privacy Policy from time to time. We will notify you of significant changes.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-2">7. Contact</h2>
          <p className="mb-4 text-gray-700">
            If you have questions about this policy, contact us at <a href="mailto:support@hintword.com" className="text-primary underline">support@hintword.com</a>.
          </p>
        </div>
      </main>
      {/* Footer */}
      <footer className="w-full py-8 px-8 flex flex-col md:flex-row items-center justify-between bg-white border-t border-gray-200 mt-auto relative z-10">
        <div className="flex items-center gap-2 text-gray-400 text-sm">
          <img src="/icons/icon.svg" alt="Logo" className="h-6 w-6" />
          <span>Hintword</span>
        </div>
        <div className="flex gap-6 text-gray-400 text-sm mt-4 md:mt-0">
          {/* <a href="/help" className="hover:underline">Help Center</a>
          <a href="/feedback" className="hover:underline">Feedback</a>
          <a href="/pricing" className="hover:underline">Pricing</a> */}
          <a href="/terms" className="hover:underline">Terms</a>
          <a href="/privacy" className="hover:underline">Privacy</a>
        </div>
      </footer>
    </div>
  );
} 